<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.66668 17.5H5.00001C4.5581 17.5001 4.13425 17.3247 3.82169 17.0123C3.50913 16.6999 3.33346 16.2762 3.33334 15.8343V4.16667C3.33322 3.72476 3.50865 3.3009 3.82104 2.98834C4.13343 2.67578 4.55719 2.50012 4.99909 2.5H15C15.4419 2.49988 15.8658 2.67531 16.1783 2.98769C16.4909 3.30008 16.6666 3.72384 16.6667 4.16575V8.33333"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.60205 6.66667H4.58334"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.60205 9.99998H4.58334"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.5 13.3334H4.58333"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.4167 17.0865V16.748C10.4194 15.785 11.1994 15.005 12.1624 15.0023H14.9235C15.8865 15.005 16.6665 15.785 16.6693 16.748V17.0865C16.6693 17.3167 16.4826 17.5033 16.2524 17.5033H10.8335C10.6033 17.5033 10.4167 17.3167 10.4167 17.0865Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.5429 12.918C14.4629 12.918 15.2091 12.1729 15.2103 11.2529C15.2115 10.3329 14.4674 9.58578 13.5474 9.58332C12.6274 9.58087 11.8793 10.324 11.8756 11.244C11.8738 11.6874 12.0487 12.1132 12.3616 12.4273C12.6745 12.7415 13.0996 12.918 13.5429 12.918V12.918Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
